import { Component, OnInit } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { TableColmuns } from "src/app/interface/TableColumnsinterface";
import { OperacionActualizadaProjection } from "src/app/models/operacionactualizadaprojection";
import { NotificacionService } from 'src/app/services/notificacion.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-vernotificaciones',
  templateUrl: './vernotificaciones.component.html',
  styleUrl: './vernotificaciones.component.scss'
})
export class VernotificacionesComponent implements OnInit {
  pagina = 0;
  offset = 0;
  limite = 100;
  totalRegistros = 0;
  userId = 0;

  listaOperaciones: OperacionActualizadaProjection[];
  listaNotificaciones: any[] = [];
  tableColumns: TableColmuns[] = [
    {
      id: "titulo",
      name: "Título",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },
    {
      id: "notificacion",
      name: "Notificación",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },
    {
      id: "fecha",
      name: "Fecha",
      isShow: true,
      isDate: true,
      isNumber: false,
      isString: false,
    },
    {
      id: "modulo",
      name: "Módulo",
      isShow: true,
      isDate: false,
      isNumber: false,
      isString: true,
    },
  ];

  operacionesColumns: string[] = [
    "titulo",
    "notificacion",
    "fecha",
    "modulo",
  ];

  cambioDePagina(event: any) {
    this.pagina = event.pageIndex;
    this.consultarOperaciones();
  }
  constructor(private toastr: ToastrService,private cookieService: CookieService,private notificacionService: NotificacionService){}
  ngOnInit():void {
    this.consultarNotificaciones();
  }
  consultarOperaciones() {
    if (this.pagina > 1) {
      this.offset += this.limite;
    } else {
      this.offset = 0;
    }
    
  }

  consultarNotificaciones() {
    this.userId = Number(
      this.cookieService.get("userId") ? this.cookieService.get("userId") : 0
    );
    if (this.userId) {
      this.notificacionService
        .listarNotificacionesPorUsuario(this.userId)
        .subscribe({
          next: (value) => {
            this.listaNotificaciones = value;
            //this.cd.markForCheck();
          },
          error: (err) => {
            this.toastr.error("Ocurrió un error consultando suscripciones");
          },
        });
    }
  }

  checkColumnaNumerica(tablecolope: any) {
    let valor =  (tablecolope.id === 
    'precioentradareal' || tablecolope.id === 
    'stoplossinicial' || tablecolope.id === 
    'preciosalidareal')  ;
   
    return valor;
  }
}
